import React, { useMemo } from "react";
import style from "./v2style.module.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";

class SetPager {
    constructor(totalCnt, viewCnt, viewPage = 10) {
        this.totalCnt = totalCnt;
        this.viewCnt = viewCnt;
        this.viewPage = viewPage;
        this.page = 1;
        
    }

    setPage(page) {
        this.page = parseInt(page);
        return this;
    }

    setViewPage(viewPage) {
        this.viewPage = parseInt(viewPage);
        this.page = 1;
        return this;
    }

    setViewCnt(viewCnt) {
        this.viewCnt = parseInt(viewCnt);
        this.page = 1;
        return this;
    }

    getSelf(page) {
        if (page) {
            this.page = page;
        }
        return this;
    }

    getItemRange() {
        let start = (this.page - 1) * this.viewCnt;
        if (start < 0) {
            start = 0;
        }
        let end = this.viewCnt * this.page;
        if (end > this.totalCnt) {
            end = this.totalCnt;
        }
        return { start, end };
    }
    getPageRange() {
        let { totalCnt, viewCnt, page, viewPage } = this
        let totalPage = totalCnt % viewCnt > 0 ? Math.floor(totalCnt / viewCnt) + 1 : Math.floor(totalCnt / viewCnt);

        let curBlock = Math.floor((page - 1) / viewPage) + 1;
        let blockBegin = (curBlock - 1) * viewPage + 1;
        let blockEnd = blockBegin + viewPage - 1;
        if (blockEnd > totalPage) blockEnd = totalPage;
        let nextPage = totalPage > blockEnd ? blockEnd + 1 : 0;
        let prevPage = curBlock > 1 ? blockBegin - 1 : 0;
        return { page: page, curBlock, blockBegin, blockEnd, nextPage, prevPage };
    }
    getIndexNO() {
        return Number(this.viewCnt) + (this.totalCnt - (this.viewCnt * this.page));
    }

}

const Pagination = (props) => {
    const { data } = props;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const setPage = (page) => {
        const reClass = data.getSelf(page);
        props.set(reClass);
    };

    const renderPagination = useMemo(() => {
        if (!data) return null;
        const pageRange = data.getPageRange();

        let renderData = [];

        if (pageRange.prevPage > 0) {
            renderData.push(
                <li
                    key={new Date().getTime() + "pagination_prev"}
                    onClick={() => setPage(pageRange.prevPage)}
                    aria-hidden={true}
                >
                    <FontAwesomeIcon icon={faAngleLeft} />
                </li>
            );
        }
        for (let i = pageRange.blockBegin; i <= pageRange.blockEnd; i++) {
            renderData.push(
                <li
                    key={new Date().getTime() + "pagination" + i}
                    className={i === pageRange.page ? style.on : ""}
                    onClick={() => setPage(i)}
                    aria-hidden={true}
                >
                    {i}
                </li>
            );
        }
        if (pageRange.nextPage > 0) {
            renderData.push(
                <li
                    key={new Date().getTime() + "pagination_next"}
                    onClick={() => setPage(pageRange.nextPage)}
                    aria-hidden={true}
                >
                    <FontAwesomeIcon icon={faAngleRight} />
                </li>
            );
        }

        

        return renderData;
    }, [data, setPage]);

    return <ul className={`${props.v2 ? style.paginationBox_v2 : style.paginationBox}`}>{renderPagination}</ul>;
};

export default Pagination;
export { SetPager };
